import { render, staticRenderFns } from "./MsgCreate.vue?vue&type=template&id=50bc26af&scoped=true"
import script from "./MsgCreate.vue?vue&type=script&lang=js"
export * from "./MsgCreate.vue?vue&type=script&lang=js"
import style0 from "./MsgCreate.vue?vue&type=style&index=0&id=50bc26af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bc26af",
  null
  
)

export default component.exports